<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
import echartsLiquidfill from 'echarts-liquidfill'
export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.chartData || {})
        },
        setOptions(data) {
            let _this = this;
            this.chart.setOption({
                title: { // 标题
                    text: '平台可调动资源剩余',
                    textStyle: { // 标题的样式
                        color: _this.isbig ? '#4AE8C8' : '#666', // 字体颜色
                        fontSize: 18,
                        align: 'center', // 文字的水平方式
                        baseline: 'middle',
                        position: 'inside',
                        verticalAlign: 'middle' // 文字的垂直方式
                    },
                    left: 'center', // 定位
                    top: '30%'
                },
                series: [{
                    type: 'liquidFill',
                    radius: '90%',
                    waveAnimation: true,
                    data: [{
                        value: 0.5,
                        direction: 'left',
                        itemStyle: {
                            normal: {
                                color: _this.isbig ? '#058ef6' : 'rgba(24,144,255,0.8)'
                            }
                        }
                    }],
                    outline: {
                        // show: true , //是否显示轮廓 布尔值
                        borderDistance: 1, // 外部轮廓与图表的距离 数字
                        itemStyle: {
                            borderColor: _this.isbig ? '#058ef6' : '#1890ff', // 边框的颜色
                            borderWidth: 5 // 边框的宽度
                            // shadowBlur: 5 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
                            // shadowColor: '#000' //外部轮廓的阴影颜色
                        }
                    },
                    itemStyle: {
                        opacity: 0.9, // 波浪的透明度
                        shadowBlur: 0 // 波浪的阴影范围
                    },
                    backgroundStyle: {
                        color: '#fff' // 图表的背景颜色
                    },
                    label: { // 数据展示样式
                        show: true,
                        color: _this.isbig ? '#4AE8C8' : '#000',
                        insideColor: '#fff',
                        fontSize: 24,
                        fontWeight: 400,
                        align: 'center',
                        baseline: 'middle',
                        position: 'inside'
                    }

                }]
            })
        }
    }
}

</script>
